import { render, staticRenderFns } from "./provider-badge.vue?vue&type=template&id=00373b24&scoped=true"
import script from "./provider-badge.vue?vue&type=script&lang=js"
export * from "./provider-badge.vue?vue&type=script&lang=js"
import style0 from "./provider-badge.vue?vue&type=style&index=0&id=00373b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00373b24",
  null
  
)

export default component.exports